import { ModalSize } from './Modal.types'

export const getModalSize = (size: ModalSize) =>
    ({
        [ModalSize.Small]: 'max-width: 50vw;',
        [ModalSize.Medium]: 'max-width: 70vw;',
        [ModalSize.Large]: 'max-width: 80vw;',
    }[size])
